var _a;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["MIGRATION_ERROR"] = 100] = "MIGRATION_ERROR";
    ErrorCode[ErrorCode["SCHEMA_VALIDATE_ERROR"] = 101] = "SCHEMA_VALIDATE_ERROR";
})(ErrorCode || (ErrorCode = {}));
export const kInternalError = Symbol('internal_error');
export class BlockSuiteError extends Error {
    constructor(code, message) {
        super(message);
        this[_a] = true;
        this.code = code;
    }
}
_a = kInternalError;
export class MigrationError extends BlockSuiteError {
    constructor(description) {
        super(ErrorCode.MIGRATION_ERROR, `Migration failed. Please report to https://github.com/toeverything/blocksuite/issues
          ${description}`);
    }
}
export class SchemaValidateError extends BlockSuiteError {
    constructor(flavour, message) {
        super(ErrorCode.SCHEMA_VALIDATE_ERROR, `Invalid schema for ${flavour}: ${message}`);
    }
}
//# sourceMappingURL=error.js.map